import { render } from "./DashboardCounters.vue?vue&type=template&id=644b4689"
import script from "./DashboardCounters.vue?vue&type=script&lang=js"
export * from "./DashboardCounters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__